"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var queue = [];
var _default = queue;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/vxe-table/lib/modal/src/queue.js
// module id = tI6D
// module chunks = 94